import WeeklyChallengeBase from "./WeeklyChallengeBase";

export default function WeeklyPostUTMEChallenge() {
  return (
    <WeeklyChallengeBase
      examType="POST_UTME"
      title="🎯 Weekly Post-UTME Challenge"
      subtitle="Real Post-UTME battle • Top scorers of the week"
    />
  );
}
